module.exports = __webpack_public_path__ + "static/img/zhongzhongka15.ceda390.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhongzhongka15.png
// module id = mi1G
// module chunks = 16